import React from 'react';
var LinkIcon = function (_a) {
    var fontColor = _a.fontColor;
    return (React.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: '16', height: '16', viewBox: '0 0 16 16', fill: 'none' },
        React.createElement("path", { d: 'M2.42948 16L0 13.5721L10.2567 3.31175H2.55146L2.57179 0H16V13.4298H12.6658L12.6861 5.73968L2.42948 16Z', fill: fontColor })));
};
export default LinkIcon;
//# sourceMappingURL=LinkIcon.js.mapimport React from 'react';
var LinkIcon = function (_a) {
    var fontColor = _a.fontColor;
    return (React.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: '16', height: '16', viewBox: '0 0 16 16', fill: 'none' },
        React.createElement("path", { d: 'M2.42948 16L0 13.5721L10.2567 3.31175H2.55146L2.57179 0H16V13.4298H12.6658L12.6861 5.73968L2.42948 16Z', fill: fontColor })));
};
export default LinkIcon;
//# sourceMappingURL=LinkIcon.js.map